import type { Service } from '@/core/domain';
import type { ServiceRepository } from '../repositories/service-repository';

export interface GetAllServicesOptions {
  forceRefresh?: boolean;
}

/** Ordem crescente por data do serviço (mais antigo primeiro); empate por `created_at`. */
function sortServicesByServiceDateAsc(services: Service[]): Service[] {
  return [...services].sort((a, b) => {
    const da = a.service_date.trim().slice(0, 10);
    const db = b.service_date.trim().slice(0, 10);
    const byDate = da.localeCompare(db);
    if (byDate !== 0) return byDate;
    return a.created_at.localeCompare(b.created_at);
  });
}

export class GetAllServicesUseCase {
  constructor(private readonly repository: ServiceRepository) {}

  async execute(userId: string, options?: GetAllServicesOptions): Promise<Service[]> {
    const list = await this.repository.getAll(userId, options?.forceRefresh === true);
    return sortServicesByServiceDateAsc(list);
  }
}
